<template>
  <div class="application-conduct-notice" :style="noticeStyle">
    <p class="notice-title">Important registration conduct notice</p>
    <p>
      Submitting this form does not guarantee that your registration will be accepted or remain valid.
      The organizing committee may review, cancel, or reject any registration involving misconduct.
    </p>
    <p>
      Misconduct includes false or fabricated information, abusive or offensive words in names or email
      addresses, rude or disrespectful communication, harassment, fraudulent payment behavior, chargeback
      or refund abuse, duplicate or misleading submissions, or any action that disrupts the event or
      disrespects the organizing committee.
    </p>
    <p class="notice-warning">
      We reserve the right to cancel the registration and blacklist the applicant from future EAE programs.
    </p>
  </div>
</template>

<script>
export default {
  name: 'ApplicationConductNotice',
  props: {
    themeColor: {
      type: String,
      default: '#F55443'
    }
  },
  computed: {
    noticeStyle() {
      const color = this.themeColor || '#F55443'
      return {
        '--notice-color': color,
        '--notice-border': this.hexToRgba(color, 0.35),
        '--notice-bg': this.hexToRgba(color, 0.06)
      }
    }
  },
  methods: {
    hexToRgba(hex, alpha) {
      const raw = (hex || '').replace('#', '')
      if (raw.length !== 3 && raw.length !== 6) {
        return `rgba(245, 84, 67, ${alpha})`
      }
      const full = raw.length === 3
        ? raw.split('').map(ch => ch + ch).join('')
        : raw
      const r = parseInt(full.slice(0, 2), 16)
      const g = parseInt(full.slice(2, 4), 16)
      const b = parseInt(full.slice(4, 6), 16)
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
  }
}
</script>

<style scoped>
.application-conduct-notice {
  width: min(900px, 100%);
  margin: 0 auto 18px;
  padding: 14px 16px;
  box-sizing: border-box;
  border: 1px solid var(--notice-border, #f5b7a9);
  border-left: 4px solid var(--notice-color, #f55443);
  background: var(--notice-bg, #fff7f5);
  color: #4a4a4a;
  font-size: 13px;
  line-height: 1.55;
  text-align: left;
}

.application-conduct-notice p {
  margin: 6px 0;
}

.notice-title {
  color: var(--notice-color, #c63d2f);
  font-weight: bold;
  font-size: 15px;
}

.notice-warning {
  color: var(--notice-color, #c63d2f);
  font-weight: bold;
}
</style>
